"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const offerstore_api_models_1 = require("@integration/offerstore-api-models");
const enums_1 = require("../../enums");
class GetNextBestOfferResponseV2WithBanner extends offerstore_api_models_1.GetNextBestOfferResponseOfferV2 {
    constructor(other) {
        super();
        Object.assign(this, other);
        this.bannerType = enums_1.BannerType.OFFER;
    }
}
exports.default = GetNextBestOfferResponseV2WithBanner;
